<template>
  <section class="mainSection">
    <h2>Projects</h2>
    <template v-for="item of items">
      <router-link :key="item.id_num" :to=" 'project/' + item.url_title ">
        <p>{{ item.title }}</p>
      </router-link>
    </template>
  </section>
</template>

<script>
export default {
  name: "Showcase",
  data() {
    return {
      items: []
    };
  },
  created: function() {
    this.items = this.$store.getters.allItems;
  }
};
</script>

<style scoped lang="scss">
section.mainSection {
  h2 {
    font-size: 1.2rem;
  }

  p {
    font-size: 1.1rem;
    font-weight: 500;
    padding: 0.2rem;
    color: $darkPrimary;
    transition: color 0.5s ease;
    &:hover {
      font-weight: bold;
      color: $accentPrimary;
    }
  }
}
a:visited {
  color: $darkSecondary;
}
</style>
